(function(){
  /* copy: internal — buy-path JS, not persuasion.
     MODE-AWARE buy path. #1811 (Kalp 2026-09-01) REVERSES the fail-closed rule of #1354/#1416:
     a missing or broken selling plan DEGRADES to a one-time sale and fires atc_plan_fallback —
     "at least they can go to checkout... better than they click add to cart, nothing happens."
     A dead button is the only forbidden state; the fallback event makes degradation loud
     (buypath_monitor + PostHog pick it up).
     #1803/#1809: NO hardcoded plan ids — the card's data-selling-plan-id is rendered live from
     the variant's own selling_plan_allocations by promised cadence; empty means the store
     really has no plan attached, and the sale proceeds one-time.
     Direct to checkout: clear -> add (retry once) -> plan-less retry -> /checkout. The
     /cart/<vid>:1 permalink stays BANNED (drops the selling plan). */
  window.evSub=true;
  var inflight=false;
  function pause(ms){return new Promise(function(res){setTimeout(res,ms)})}
  function subMode(){return (window.__hxMode||'sub')==='sub';}
  function ph(ev,props){try{window.posthog&&posthog.capture(ev,props)}catch(_){}}
  window.evAddToCart=function(vid,qty,btn){
    if(inflight) return;
    var box=document.querySelector('.offer-box[data-variant-id="'+vid+'"],.prdoff-offer-box[data-variant-id="'+vid+'"]');
    var sub=subMode();
    var plan=sub?((box&&box.dataset.sellingPlanId)||""):"";
    if(sub&&!plan) ph("atc_plan_fallback",{offer:"everly",variant_id:String(vid),reason:"no_plan_at_click"});
    inflight=true;
    var item={id:parseInt(String(vid),10),quantity:parseInt(qty,10)||1};
    if(plan) item.selling_plan=parseInt(plan,10);
    ph("add_to_cart",{offer:"everly",variant_id:String(vid),purchase_type:item.selling_plan?"subscription":"one_time"});
    function add(){return fetch("/cart/add.js",{method:"POST",priority:"high",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[item]})})}
    fetch("/cart/clear.js",{method:"POST",priority:"high"}).then(function(){return pause(120)}).then(add)
      .then(function(r){ if(r.ok) return r; return pause(800).then(add); })
      .then(function(r){
        if(r.ok){ location.href="/checkout"; return; }
        if(item.selling_plan){
          delete item.selling_plan;
          ph("atc_plan_fallback",{offer:"everly",variant_id:String(vid),reason:"add_failed_with_plan"});
          return add().then(function(r2){ if(!r2.ok) throw 0; location.href="/checkout"; });
        }
        throw 0;
      })
      .catch(function(){
        inflight=false;
        document.querySelectorAll(".loading_hk").forEach(function(b){b.classList.remove("loading_hk")});
      });
  };
  function wire(){
    var c=document.getElementById("auto-refill");c&&(c.checked=subMode());
    /* the old wire() also STAMPED a hardcoded fallback plan onto cards missing a
       data-selling-plan-id — removed (#1809): an empty plan is a true store fact now,
       and stamping a stale id is how a wrong subscription gets sold. */
  }
  document.readyState!=="loading"?wire():document.addEventListener("DOMContentLoaded",wire)
})();
